import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { ItemPlace } from 'src/app/site/shared-components/item-location-overlay/models/model';
import { IBranch } from 'src/app/site/feature-modules/search-branch/models/branch.model';
import { TranslateService } from '@ngx-translate/core';
import { ICompanyInfo } from 'src/app/site/feature-modules/welcome/models/welcome.models';
import { PagesConfig } from '../defines/pages.config';
import { Router } from '@angular/router';
import { ClientDetails } from 'src/app/site/feature-modules/profile/models/profile';
import { LocalStorageService } from 'src/locallocalStorage.service';
export function detectEnv() { }

@Injectable({
  providedIn: 'root',
})
export class commonService {
  isVisitor: boolean = true;
  selectedPlace: ItemPlace | null = null;
  customHeader: any;
  itemPlace$: Subject<ItemPlace> = new Subject<ItemPlace>();
  branch$: Subject<IBranch> = new Subject<IBranch>();
  loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  error$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  searchItems$: Subject<string> = new Subject<string>();

  // companyInfo$: BehaviorSubject<ICompanyInfo | null> = new BehaviorSubject<ICompanyInfo | null>(null);
  // getCompanyInfo$ = this.companyInfo$.asObservable();

  selectedBranch: IBranch | null = null;

  clientDetails$: BehaviorSubject<ClientDetails | null> = new BehaviorSubject<ClientDetails | null>(null);
  clientDetailsObs$ = this.clientDetails$.asObservable();
  header$: BehaviorSubject<'fixed' | 'relative'> = new BehaviorSubject<'fixed' | 'relative'>('fixed');
  constructor(
    private translate?: TranslateService,
    private router?: Router,
    private localStorageService?: LocalStorageService
  ) { }

  setHeader(header: 'fixed' | 'relative') {
    this.header$.next(header);
  }

  get isLoading(): boolean {
    return this.loading$.getValue();
  }


  get hasError(): boolean {
    return this.error$.getValue();
  }

  setClientDetails(clientDetails: ClientDetails | null): void {
    this.clientDetails$.next(clientDetails);
  }

  // setCompanyInfo(companyInfo: ICompanyInfo | null): void {
  //   this.companyInfo$.next(companyInfo);
  // }

  isLoggedIn(): boolean {
    return !!this.getToken();
  }
  getCompanyIdentifier(): string {
    const companyIdentifier = this.localStorageService?.getItem('companyIdentifier');
    if (companyIdentifier) {
      return companyIdentifier;
    }
    return '';
  }

  setCompanyIdentifier(companyIdentifier: string): void {
    this.localStorageService?.setItem('companyIdentifier', companyIdentifier);
  }


  setUserName(userName: string): void {
    this.localStorageService?.setItem('userName', userName);
  }

  getUserName(): string | null {
    let userName: string | null = this.localStorageService?.getItem('userName') || null;
    if (userName === null) {
      return '';
    }
    return userName;
  }

  setEmail(email: string): void {
    this.localStorageService?.setItem('email', email);
  }
  getEmail(): string | null {
    let email: string | null = this.localStorageService?.getItem('email') || null;
    if (email === null) {
      return '';
    }
    return email;
  }

  setToken(token: string): void {
    this.localStorageService?.setItem('GlameraBLToken', token);
    this.setCookie('GlameraBLToken', token, 7);


  }
  getToken(): string | null {
    let token: string | null = this.localStorageService?.getItem('GlameraBLToken') || null;
    
    if (token === null) {
      return '';
    }
    return token;
  }

  setCookie(name: string, value: string, days: number) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

  setImage(image: string): void {
    this.localStorageService?.setItem('image', image);
  }
  getImage(): string | null {
    let email: string | null = this.localStorageService?.getItem('email') || null;
    if (email === null) {
      return '';
    }
    return email;
  }

  setUserStatus(status: boolean): void {
    this.isVisitor = status;
  }
  getUserStatus(): boolean {
    return this.isVisitor;
  }

  setBranch(branch: IBranch | null): void {
    this.selectedBranch = branch;
    if (branch)
      this.branch$.next(branch);
  }
  getBranch(): IBranch | null {
    return this.selectedBranch;
  }
  clearBranch(): void {
    this.localStorageService?.removeItem('branch');
  }

  setItemPlace(place: ItemPlace) {
    this.selectedPlace = place;
    this.itemPlace$.next(place);
  }
  getItemPlace(): ItemPlace {
    return this.selectedPlace ?? ItemPlace.OnSite;
  }

  setLang(lang: string): void {
    this.translate?.use(lang);
    this.localStorageService?.setItem('lang', lang);
  }

  getLang(): string {
    let lang: any = this.localStorageService?.getItem('lang');
    if (lang === null) {
      return 'en';
    }
    return lang;
  }

  logOut(): void {
    this.localStorageService?.removeItem('GlameraBLToken');
    this.localStorageService?.removeItem('userName');
    this.localStorageService?.removeItem('email');
    window.location.href = '/';
  }
}
